/**
 * Intrinsic pixel dimensions for the bundled images, so every <img> can carry
 * explicit width/height attributes. This lets the browser reserve space and
 * compute the aspect ratio up front (better CLS / Lighthouse), even where CSS
 * (object-cover, aspect-[…]) ultimately drives the rendered size.
 */
export interface ImageDimensions {
  width: number;
  height: number;
}

const IMAGE_DIMENSIONS: Record<string, ImageDimensions> = {
  '/img/hero.webp': { width: 1920, height: 1080 },
  '/img/cta.webp': { width: 1920, height: 1080 },
  '/img/flying-dress.webp': { width: 1600, height: 1067 },
  '/img/flying-dress-home.webp': { width: 1600, height: 1021 },
  '/img/studio.webp': { width: 1600, height: 900 },
  '/img/casual.webp': { width: 1600, height: 1175 },
  '/img/casual-2.webp': { width: 1067, height: 1600 },
  '/img/santorini-tour.webp': { width: 1536, height: 1024 },
  '/img/love-story.webp': { width: 1600, height: 1326 },
  '/img/love-story-2.webp': { width: 1600, height: 1360 },
  '/img/wedding.webp': { width: 1100, height: 576 },
  '/img/logo-horizontal.webp': { width: 1054, height: 200 },
  '/img/logo-horizontal-dark.webp': { width: 1054, height: 200 },
};

/** Returns intrinsic { width, height } for a known image src, or a 4:3 fallback. */
export function imgDims(src: string): ImageDimensions {
  return IMAGE_DIMENSIONS[src] ?? { width: 1100, height: 733 };
}
